import React from 'react';
import { Icon } from './Icon.js';
export const IconCaretUpFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m7.248,2.52c-.559-.837-1.938-.837-2.496,0L1.653,7.168c-.308.461-.336,1.051-.074,1.54.262.489.769.792,1.322.792h6.197c.554,0,1.061-.303,1.322-.792.262-.488.233-1.079-.074-1.54l-3.099-4.648Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconCaretUpFill12.js.map